import Box from '@mui/material/Box';
import React, {ReactNode} from 'react';
import {sx} from './sx'

interface IProps {
    children: ReactNode
}

const RootLayoutSingleVoyage = ({children}: IProps) => {
    return (
        <Box
            sx={sx.root}
        >
            {children}
        </Box>
    );
};

export default RootLayoutSingleVoyage;